import { BookOpen } from "lucide-react";
import { Link } from "react-router-dom";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

export const Header = () => {
  return (
    <header className="border-b border-[#B85B3D]/20 bg-[#F5E6D3]">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-2 text-[#1A0F0A] hover:text-[#B85B3D] transition-colors">
          <BookOpen className="w-6 h-6" />
          <span className="text-xl font-semibold">Ed Ramsey</span>
        </Link>
        
        <Link to="/about" className="flex items-center space-x-4 hover:opacity-80 transition-opacity">
          <div className="text-right mr-4">
            <h2 className="text-sm font-medium text-[#1A0F0A]">About Me</h2>
            <p className="text-xs text-[#1A0F0A]/80">Writer & Storyteller</p>
          </div>
          <Avatar className="w-10 h-10 border-2 border-[#B85B3D]/20">
            <AvatarImage src="/lovable-uploads/ed-ramsey-headshot.jpg" alt="Ed Ramsey" />
            <AvatarFallback>ER</AvatarFallback>
          </Avatar>
        </Link>
      </div>
    </header>
  );
};